/**
 * form — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/form.ts`.
 */

export const form = {
  'print.note': 'Bitte den Knopf „PDF herunterladen“ verwenden – diese Seite ist nicht zum direkten Drucken gedacht.',
  'form.line': 'Zeile {n}',

  /* ---------------- sections ---------------- */
  'sec.flug.title': 'Flug',
  'sec.flug.nav': 'Flug',
  'sec.route.title': 'Strecke & Kontrollpunkte',
  'sec.route.nav': 'Strecke',
  'sec.zeit.title': 'Zeiten',
  'sec.zeit.nav': 'Zeiten',
  'sec.wx.title': 'Wetter-Beratung',
  'sec.wx.nav': 'Wetter',
  'sec.atis.title': 'ATIS / Platzwetter',
  'sec.atis.nav': 'ATIS',
  'sec.b1.title': 'Freigaben / Wetter / Info',
  'sec.b1.nav': 'Freigaben',
  'sec.v5.title': 'Flugsicherungs-Beratung',
  'sec.v5.nav': 'Flugsicherung',
  'sec.fq.title': 'Frequenzen',
  'sec.fq.nav': 'Frequenzen',
  'sec.aip.title': 'Flugplatz-Daten aus AIP',
  'sec.aip.nav': 'AIP',
  'sec.fuel.title': 'Kraftstoffberechnung',
  'sec.fuel.nav': 'Kraftstoff',
  'sec.mb.title': 'Masse & Schwerpunkt',
  'sec.mb.nav': 'Masse',
  'sec.tl.title': 'Start- & Landestrecken',
  'sec.tl.nav': 'Start/Landung',

  /* ---------------- field labels (aria/tooltip) ---------------- */
  'lbl.datum': 'Datum',
  'lbl.von': 'Startflugplatz (von)',
  'lbl.nach': 'Zielflugplatz (nach)',
  'lbl.lfz_muster': 'LFZ-Muster',
  'lbl.lfz_kennz': 'LFZ-Kennzeichen',
  'lbl.etd': 'ETD – voraussichtliche Startzeit (UTC)',
  'lbl.atd': 'ATD – tatsächliche Startzeit',
  'lbl.eta': 'ETA – voraussichtliche Ankunftszeit',
  'lbl.ata': 'ATA – tatsächliche Ankunftszeit',
  'lbl.ss': 'SS – Sonnenuntergang (UTC)',
  'lbl.safe_time': 'Sichere Flugzeit (max. Flugzeit − 30 min)',
  'lbl.total_dist': 'Gesamtentfernung (P14)',
  'lbl.total_time': 'Gesamtflugzeit (P18)',
  'lbl.gafor': 'GAFOR-Gebiete/Werte',
  'lbl.gafor_check': 'GAFOR-Beratung erfolgt',
  'lbl.gafor_bis': 'Beratung gültig bis (UTC)',
  'lbl.fuel_vorrat_zeit': 'Kraftstoff-Vorrat: max. Flugzeit',
  'lbl.fuel_safe_time': 'Sichere Flugzeit',
  'lbl.alt_name': 'Ausweichflugplatz',

  /* label patterns */
  'lbl.legRow': 'Abschnitt {n}: {what}',
  'lbl.altRow': 'Ausweichstrecke: {what}',
  'lbl.freigabenRow': 'Freigaben/Wetter/Info, Zeile {n}',
  'lbl.fqRow': 'Frequenz {where}: {what}',
  'lbl.atisRow': 'ATIS Zeile {n}: {what}',
  'lbl.cpRow': '{what} (Zeile {n})',
  'lbl.fsRow': 'Flugsicherungs-Beratung, Zeile {n}',
  'lbl.wxRow': 'Wetter-Beratung, Zeile {n}',
  'lbl.aipRow': 'AIP {where}: {what}',
  'lbl.fuelRow': 'Kraftstoff {row}: {what}',
  'lbl.verbrauchRow': 'Daten über Verbrauch, Zeile {n}',
  'lbl.mbUnit': 'Einheit {what}',
  'lbl.mbRow': '{row}: {what}',
  'lbl.tlRow': '{row} – {col}',

  /* frequencies */
  'fq.dep': 'Startflugplatz',
  'fq.dest': 'Zielflugplatz',
  'fq.ground': 'Rollkontrolle',
  'fq.twr': 'Turm',
  'fq.info': 'INFO',

  /* AIP */
  'aip.p1': 'Startflugplatz',
  'aip.p2f': 'Zielflugplatz',
  'aip.p20': 'Ausweichflugplatz',
  'aip.rwy': 'Bahnrichtung',
  'aip.len': 'Bahnlänge (m)',
  'aip.dist15': 'Strecke 15 m',
  'aip.elev': 'Höhe (ft)',
  'aip.temp': 'Temperatur',
  'aip.wind': 'Wind',
  'aip.slope': 'Neigung',
  'aip.belag': 'Belag',
  'aip.gras': 'Grasbahn',
  'aip.surface': 'Oberflächenzustand',
  'aip.restr': 'Beschränkungen',

  /* fuel */
  'fuel.reise': 'Reiseflug',
  'fuel.anlassen': 'Anlassen/Rollen',
  'fuel.steig': 'Steigflug',
  'fuel.anab': 'An- und Abflug',
  'fuel.altn': 'Ausweichflugplatz',
  'fuel.reserve': 'Reserve',
  'fuel.mindest': 'Mindest-Kraftstoffbedarf',
  'fuel.extra': 'Extra-Kraftstoff',
  'fuel.vorrat': 'Kraftstoff-Vorrat',
  'fuel.zeit': 'Flugzeit',
  'fuel.liter': 'Liter',

  /* mass & balance */
  'mb.masse': 'Masse',
  'mb.moment': 'Moment',
  'mb.leer': 'Leermasse',
  'mb.kna': 'Kraftstoff, nicht ausfliegbar',
  'mb.schmier': 'Schmierstoff',
  'mb.grund': 'Grundmasse',
  'mb.sitz1': 'Sitzreihe 1',
  'mb.sitz2': 'Sitzreihe 2',
  'mb.sitz3': 'Sitzreihe 3',
  'mb.gep_vorn': 'Gepäck vorn',
  'mb.gep_mitte': 'Gepäck Mitte',
  'mb.gep_hinten': 'Gepäck hinten',
  'mb.kausf': 'Kraftstoff, ausfliegbar',
  'mb.start': 'Startmasse',

  /* take-off & landing distances */
  'tl.bahn': 'Vorhandene Bahnlänge',
  'tl.verf': 'Verfügbare Strecke (15 m)',
  'tl.grund': 'Grundstrecke (Flughandbuch)',
  'tl.hoehe': 'Höhenzuschlag',
  'tl.temp': 'Temperaturzuschlag',
  'tl.wind': 'Windeinfluß',
  'tl.neig': 'Neigungszuschlag',
  'tl.gras': 'Grasbahnzuschlag',
  'tl.oberfl': 'Oberflächenzuschlag',
  'tl.benoetigt': 'Benötigte Strecke',
  'tl.sr': 'Start: Rollstrecke',
  'tl.ss': 'Startstrecke',
  'tl.ll': 'Landestrecke',
  'tl.lr': 'Landung: Rollstrecke',

  /* ---------------- form captions ---------------- */
  'form.view': 'Formular-Ansicht',
  'form.sections': 'Abschnitte',
  'form.dep': 'Start',
  'form.dest': 'Ziel',
  'form.alt': 'Ausweich',
  'form.total': 'Gesamt',
  'form.leg': 'Abschnitt {n}',
  'form.datum': 'Datum',
  'form.date.ph': 'TT.MM.JJJJ',
  'form.von': 'Von (Startflugplatz)',
  'form.nach': 'Nach (Zielflugplatz)',
  'form.lfz_kennz.ph': 'D-….',
  'form.aircraft': 'Luftfahrzeug',
  'form.aircraft.aria': 'Luftfahrzeug dieses Plans',
  'form.aircraft.empty': 'keines',
  'form.aircraft.manage': 'Flugzeuge verwalten →',
  'form.aircraft.none': 'Flugzeug anlegen →',

  'form.route.note': 'Wind als GGG/KK, VAR mit Vorzeichen. WCA, mwSK, mwK, GS und Zeiten rechnen sich daraus.',
  'card.name': 'Ziel-Kontrollpunkt',
  'card.dep': 'Startflugplatz',
  'card.rest_dist': 'Rest NM',
  'card.rest_time': 'Rest min',
  'card.total_dist': 'Gesamt NM',
  'card.total_time': 'Gesamt min',

  'form.etd': 'ETD (UTC)',
  'form.atd': 'ATD',
  'form.eta': 'ETA',
  'form.ata': 'ATA',
  'form.safe_time': 'Sichere Flugzeit',

  'form.gafor_check': 'GAFOR-Beratung',
  'form.gafor_bis': 'gültig bis (UTC)',
  'form.gafor': 'GAFOR-Gebiete/Codes',
  'form.wx.note':
    'Ersetzt keine amtliche Flugwetterberatung.',
  'form.wx.lines': 'Wetter-Beratung (Zeilen des Formblatts):',

  'form.atis.station': 'Station/Frequenz',
  'form.atis.code': 'Code',
  'form.atis.rwy': 'RWY',
  'form.atis.tl': 'TL',
  'form.atis.zeit': 'Zeit (UTC)',
  'form.atis.wind': 'Wind',
  'form.atis.sicht': 'Sicht',
  'form.atis.wolken': 'Wolken',
  'form.atis.temp': 'Temp./Taup.',
  'form.atis.qnh': 'QNH',
  'form.atis.tendenz': 'Tendenz',

  'form.aip.rwy': 'Bahnrichtg.',
  'form.aip.len': 'Bahnlänge (m)',
  'form.aip.dist15': 'Strecke 15 m',
  'form.aip.elev': 'Höhe (ft)',
  'form.aip.temp': 'Temp. (°C)',
  'form.aip.wind': 'Wind (° kt)',
  'form.aip.slope': 'Neigung',
  'form.aip.belag': 'Belag',
  'form.aip.gras': 'Gras',
  'form.aip.surface': 'Oberflächenzustand',
  'form.aip.restr': 'Beschränkungen',
  'belag.asph': 'ASPH – Asphalt',
  'belag.beton': 'Beton',
  'belag.gras': 'Gras',
  'belag.schotter': 'Schotter',
  'belag.sand': 'Sand',

  'form.fuel.reise': 'Reiseflug (Startort–Landeort)',
  'form.fuel.anlassen': 'Zuschlag: Anlassen, Rollen',
  'form.fuel.steig': 'Zuschlag: Steigflug',
  'form.fuel.anab': 'An- und Abflug (mind. 10 min)',
  'form.fuel.altn': 'Ausweichflugplatz',
  'form.fuel.reserve': 'Reserve (mind. 30 min)',
  'form.fuel.mindest': 'Mindest-Kraftstoffbedarf',
  'form.fuel.extra': 'Extra-Kraftstoff',
  'form.fuel.vorrat': 'Kraftstoff-Vorrat (max. Flugzeit)',
  'form.fuel.safe': 'Sichere Flugzeit (= max. − 30 min)',
  'form.fuel.verbrauch': 'Daten über Verbrauch',

  'form.mb.units': 'Einheiten',
  'form.mb.unit_masse': 'Masse-Einheit',
  'form.mb.unit_moment': 'Moment-Einheit',
  'form.tl.note': 'Benötigte Strecke = Grundstrecke + alle Zuschläge.',

  /* ---------------- shared view ---------------- */
  'shared.readonly': 'geteilte Ansicht (nur lesen)',
  'shared.own': 'Eigenen Plan anlegen',
  'shared.invalid': 'Der Link ist ungültig oder abgelaufen.',

  'form.pane.note': 'Das Formblatt, wie es gedruckt wird.',
  'shared.madeWith': 'Erstellt mit Aether',
} as const;
